module.exports = __webpack_public_path__ + "static/media/watch.421042ac.png";